import MessageSender from '../sender'
import BaseMessage from '../message'

export default () => async () => {
  const msg = new BaseMessage()
  msg.setPath('auth/datareg')
  const response = await new MessageSender().doPost(msg)
  if (response.isOK()) {
    return response.getResultAsObject()
  }
  return false
}
